import React, { useState, useEffect } from 'react';
import { SFuncModal, SModalSelected, SFormUploadImage } from 'shj-components';
import { Form, Button, Input, Row, Col, Divider, Select, Space, message } from 'antd';
import ImageUpload from '@/components/Upload/ImageUpload'
import { modalCodeFn } from '@/pages/fmsConfig/receiptRulesManagement/components/codeRule';
import { receiptRulesPlanMainPageList, esignCommonList, specialRulesDetailAdd, specialRulesDetailUpdateById } from '@/services/fmsConfig'
import { get, isNil } from 'lodash-es';
const { TextArea } = Input;
const ModalContent: React.FC<any> = ({ onClose, fn, initialValues }) => {
  const [form] = Form.useForm();
  const [companyList, setCompanyList] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);
  const [isDisabled, setIsDisabled] = useState<any>(false);
  const [planMainName, setPlanMainName] = useState<any>('');
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const getFilePath = (file: any) => get(file[0], 'response.data.filePath') || get(file[0], 'fullUrl');
      const fileFields = ['fileUrl'];
      fileFields.forEach(field => {
        if (values[field]) {
          values[field] = getFilePath(values[field]);
        }
      });
      values.labelId = initialValues.programmeId
      values.fmsMainIds = values.fmsMainIds && values.fmsMainIds.join(',')
      setLoading(true)
      if (initialValues?.id) {
        if(initialValues.showCopy){
          specialRulesDetailAdd(values).then((res) => {
            message.success(res?.message || '操作成功');
            onClose();
            fn && fn();
            setLoading(false)
          }).catch(err => {
            setLoading(false)
          })
        }else{
          specialRulesDetailUpdateById(values).then((res) => {
            message.success(res?.message || '操作成功');
            onClose();
            fn && fn();
            setLoading(false)
          }).catch(err => {
            setLoading(false)
          })
        }
      } else {
        specialRulesDetailAdd(values).then((res) => {
          message.success(res?.message || '操作成功');
          onClose();
          fn && fn();
          setLoading(false)
        }).catch(err => {
          setLoading(false)
        })
      }
    } catch (error) {
      console.error('表单验证失败:', error);
    }
  };
  const config = {
    rowSelectionType: 'radio',
    columns: [
      {
        "title": "收款计划名称",
        "dataIndex": "name",
        "width": 180,
        "ellipsis": true
      },
      {
        "title": "描述",
        "dataIndex": "remarks",
        "width": 200,
        "ellipsis": true
      },
      {
        "title": "状态",
        "dataIndex": "enabledName",
        "width": 100,
      },
      {
        "title": "创建人",
        "dataIndex": "createdByName",
        "width": 100
      },
      {
        "title": "创建日期",
        "dataIndex": "createdTime",
        "itemType": "date",
        "width": 140
      },
      {
        "title": "是否默认",
        "dataIndex": "isDefault",
        "width": 100,
        "render": (text) => {
          return text ? '是' : '否'
        }
      },
    ],
    search: [
      {
        "name": "name",
        "label": "计划名称",
        "addonOpts": ["=", "∈"]
      },
    ],
    searchMode: "group"
  };
  useEffect(() => {
    getOptions()
    //复制
    if (initialValues.showCopy) {
      const { id, rulesDesc, ...rest } = initialValues;
      form.setFieldsValue({ id: undefined, rulesDesc: '' });
      initialValues = rest;
    }
    if (initialValues.id) {
      form.setFieldsValue({ id: initialValues.id });
      setIsDisabled(initialValues.disabled || false);
    }
    if (initialValues.planMainName) {
      setPlanMainName(initialValues.planMainName);
      form.setFieldsValue({
        planMainId: initialValues.planMainId,
        planMainName: initialValues.planMainName,
      });
    }

  }, []);
  const getOptions = async () => {
    const esignCompanyList = await esignCommonList() //财务主体
    setCompanyList(esignCompanyList)
  }
  const getTableList = async (value) => {
    value.query.enabled = 1
    let data = await receiptRulesPlanMainPageList(value.current, value.pageSize, value.query);
    const { records, total } = data;
    return { records, total };
  };
  const getSelectedRow = (v, o) => {
    if(o.length !== 0){
      form.setFieldsValue({
        planMainId: o[0].id,
        planMainName: o[0].name
      })
      setPlanMainName(o[0].name)
    }else{
      setPlanMainName('')
      form.setFieldsValue({
        planMainId: '',
        planMainName: ''
      })
    }
  };
  const openEditRule = (specialData: any) => {
    specialData.ruleType = 'special'
    specialData.programmeId = initialValues.programmeId
    specialData.desc = form.getFieldValue('rulesCalName');
    specialData.code = form.getFieldValue('rulesCal');
    modalCodeFn({
      fn: (data) => {
        // 设置取数规则的值
        form.setFieldsValue({
          rulesCalName: data.desc.join(' '),
          rulesCal: data.code.join(' ')
        })
      },
      ...specialData,
    });
  }
  return (
    <div style={{ padding: 15 }}>
      <Form form={form} initialValues={initialValues} layout={'vertical'}>
        <Form.Item name="id" label="id" style={{ display: 'none' }}>
          <Input disabled />
        </Form.Item>
        <Form.Item name="rulesDesc" label="规则描述" rules={[{ required: true, message: '请输入规则描述' }]}>
          <Input disabled={isDisabled} placeholder="请输入规则描述" maxLength={50}  />
        </Form.Item>
        <Form.Item name="planMainId" label="收款计划" style={{ display: 'none' }}>
          <Input />
        </Form.Item>
        <Form.Item name="planMainName" label="收款计划" rules={[{ required: true, message: '收款计划' }]}>
          <SModalSelected
            inputButtonLabel="选择"
            disabled={isDisabled}
            selectType="table"
            inputName="name"
            config={config}
            defaultInputValue={planMainName}
            modalProps={{
              title: '请选择收款计划',
              cancelText: '取消',
              okText: '确定',
              width: 1000,
            }}
            getTableList={getTableList}
            onChange={getSelectedRow}
          />
        </Form.Item>
        <Form.Item name="fmsMainIds" label="适用财务主体" rules={[{ required: true, message: '请选择财务主体' }]}>
          <Select disabled={isDisabled} mode='multiple' placeholder="请选择财务主体" allowClear showSearch optionFilterProp="children">
            {companyList &&
              companyList.map((item: any, index: number) => {
                return (
                  <Select.Option key={index} value={item.companyConfigId}>
                    {item.companyFullName}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item label="上传附件" name="fileUrl" rules={[{ required: true, message: '请上传附件' }]} extra="支持.pdf,jpg等">
          <ImageUpload disabled={isDisabled} listType={'text'} limit={1} />
        </Form.Item>
        <Form.Item name="remarks" label="备注">
          <TextArea disabled={isDisabled} rows={4} placeholder='备注' maxLength={50} />
        </Form.Item>
        <Form.Item name="rulesCal" label="取数规则" style={{ display: 'none' }}>
          <Input disabled={isDisabled} />
        </Form.Item>
        <Form.Item label="取数规则" style={{marginBottom: 0}}>
          <Space direction="horizontal" style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Form.Item name="rulesCalName">
              <Input placeholder="取数规则" disabled={true} />
            </Form.Item>
            <Button type="primary" disabled={isDisabled} onClick={openEditRule}>编辑</Button>
          </Space>
        </Form.Item>
        {/* 在这里添加更多的表单项 */}
        {
          !isDisabled ? <Form.Item style={{marginBottom: 10}}>
            <Row>
              <Col span={24}>
                <Divider />
              </Col>
              <Col span={24} style={{ textAlign: 'right' }}>
                <Button onClick={onClose} style={{ marginRight: 8 }}>
                  取消
                </Button>
                <Button type="primary" onClick={handleSubmit} loading={loading}>
                  确定
                </Button>
              </Col>
            </Row>
          </Form.Item> : null
        }
      </Form>
    </div>
  );
};

export const showModalTemplate = (props: any) => {
  const { title, fn, initialValues } = props;
  const onClose = () => {
    modal.destroy();
  };
  const modal = SFuncModal({
    title,
    width: 500,
    vanish: true,
    content: <ModalContent title={title} onClose={onClose} fn={fn} initialValues={initialValues} />,
  });

  return modal;
};